import { Priority } from '@a46-rss/shared';

interface PriorityFilterProps {
  selected: Priority[];
  onChange: (priorities: Priority[]) => void;
}

const priorities: { value: Priority; label: string; color: string }[] = [
  { value: 1, label: 'P1 最高', color: 'bg-red-100 text-red-800 border-red-300' },
  { value: 2, label: 'P2 高', color: 'bg-orange-100 text-orange-800 border-orange-300' },
  { value: 3, label: 'P3 中', color: 'bg-yellow-100 text-yellow-800 border-yellow-300' },
  { value: 4, label: 'P4 低', color: 'bg-green-100 text-green-800 border-green-300' },
  { value: 5, label: 'P5 最低', color: 'bg-gray-100 text-gray-600 border-gray-300' },
];

export default function PriorityFilter({ selected, onChange }: PriorityFilterProps) {
  const togglePriority = (priority: Priority) => {
    if (selected.includes(priority)) {
      onChange(selected.filter((p) => p !== priority));
    } else {
      onChange([...selected, priority].sort());
    }
  };

  const selectAll = () => {
    onChange([1, 2, 3, 4, 5]);
  };

  const clearAll = () => {
    onChange([]);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">優先度</span>
        <div className="space-x-2">
          <button
            onClick={selectAll}
            className="text-xs text-blue-600 hover:text-blue-800"
          >
            全選択
          </button>
          <button
            onClick={clearAll}
            className="text-xs text-gray-500 hover:text-gray-700"
          >
            クリア
          </button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {priorities.map(({ value, label, color }) => (
          <button
            key={value}
            onClick={() => togglePriority(value)}
            className={`px-3 py-1 text-xs font-medium rounded-full border transition-all ${
              selected.includes(value)
                ? color
                : 'bg-white text-gray-500 border-gray-200 hover:border-gray-400'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
